import { InjectionToken } from "@angular/core";

export const BOOKING_SERVICE_TOKEN = new InjectionToken('booking.service');